import React from 'react';
import classNames from 'classnames';
import ExtendSearchBase from './ExtendSearchBase';
import { Select, Checkbox, RadioGroup } from '../../Controls';
import { SALE, APARTMENTS } from '../../../consts';
import { getAgencies } from '../../../utils/dictionaries';

class SaleApartments extends ExtendSearchBase {
  constructor (props) {
    super(props);
    this.displayName = 'saleApartments';
    const dic = props.dictionary;

    this.deadlineItems = dic.getDeadlineItems();
    this.floorPositionItems = dic.getFloorPositionItems(SALE, APARTMENTS);
    this.planningItems = dic.getPlanningItems(SALE, APARTMENTS);
    this.sanitaryItems = dic.getSanitaryItems(SALE, APARTMENTS);
    this.renovationTypeItems = dic.getRenovationTypeItems(SALE, APARTMENTS);
    this.windowTypeItems = dic.getWindowTypeItems(SALE, APARTMENTS);
    this.windowViewItems = dic.getWindowViewItems(SALE, APARTMENTS);
    this.buildingTypeItems = dic.getBuildingTypeItems(SALE, APARTMENTS);
    this.materialTypeItems = dic.getMaterialTypeItems(SALE, APARTMENTS);
    this.applicationItems = dic.getApplicationItems(SALE, APARTMENTS);
    this.cornerItems = dic.getCornerItems();
    this.authorItems = dic.getAuthorItems();
    this.agenciesList = getAgencies(props.agenciesList, this.displayName);

  }

  renderIsRelease () {
    const isNew = this.getFilter('isNewBuilding');
    const isResale = this.getFilter('isResale');
    const anyClass = classNames('btn btn-base', { pressed: !isNew && !isResale });
    const releaseClass = classNames('btn btn-base', { pressed: isResale });
    const newClass = classNames('btn btn-base', { pressed: isNew });

    const handler = (key) => {
      return () => {
        const state = {
          isNewBuilding: key === 'new' ? 1 : null,
          isResale: key === 'resale' ? 1 : null,
          deadlineId: null
        };

        this.setFilter(state);
      };
    };

    return this.renderControlGroup('', (
      <div className='btn-group-pills btn-group-new-old' role='group'>
        <button type='button' onClick={handler()} className={anyClass}>Неважно</button>
        <button type='button' onClick={handler('new')} className={newClass}>Новостройки</button>
        <button type='button' onClick={handler('resale')} className={releaseClass}>Вторичное жилье</button>
      </div>
    ));
  }

  renderAuthor () {
    const onlyOwners = this.getFilter('onlyOwners');
    const onlyFromBuilder = this.getFilter('onlyFromBuilder');
    const anyClass = classNames('btn btn-base', { pressed: !onlyOwners && !onlyFromBuilder });
    const releaseClass = classNames('btn btn-base', { pressed: onlyOwners });
    const newClass = classNames('btn btn-base', { pressed: onlyFromBuilder });

    const handler = (val) => {
      return () => {
        const state = {
          onlyOwners: val === 'onlyOwners' ? 1 : null,
          onlyFromBuilder: val === 'onlyFromBuilder' ? 1 : null
        };

        this.setFilter(state);
      };
    };

    return this.renderControlGroup('Автор', (
      <div className='btn-group-pills btn-group-is-owner' role='group'>
        <button type='button' onClick={handler()} className={anyClass}>Неважно</button>
        <button type='button' onClick={handler('onlyOwners')} className={releaseClass}>От частников</button>
        <button type='button' onClick={handler('onlyFromBuilder')} className={newClass}>От застройщиков</button>
      </div>
    ));
  }

  /**
   * Переопределенный метод, для отображения фильтров
   * @returns {XML}
   */
  renderPanel () {
    return (<div>
      <div className='filter-section__container'>
        <h3 className='title'>Параметры квартиры</h3>
        <div className='container__row'>
          <div className='container__column'>
            {this.renderInputGroup('Общая площадь, м²', null, [
              {name: 'squareTotalMin', placeholder: 'От', handler: this.getHandlerFloat('squareTotalMin', 7)},
              {name: 'squareTotalMax', placeholder: 'До', handler: this.getHandlerFloat('squareTotalMax', 7)}
            ])}

            {this.renderInputGroup('Жилая площадь, м²', null, [
              {name: 'squareLivingMin', placeholder: 'От', handler: this.getHandlerFloat('squareLivingMin', 7)},
              {name: 'squareLivingMax', placeholder: 'До', handler: this.getHandlerFloat('squareLivingMax', 7)}
            ])}

            {this.renderInputGroup('Площадь кухни, м²', null, [
              {name: 'squareKitchenMin', placeholder: 'От', handler: this.getHandlerFloat('squareKitchenMin', 7)},
              {name: 'squareKitchenMax', placeholder: 'До', handler: this.getHandlerFloat('squareKitchenMax', 7)}
            ])}

            {this.renderInputGroup('Этаж', (
              <Select
                name='floorPositionId'
                items={this.floorPositionItems}
                value={this.getFilter('floorPositionId')}
                onUpdate={(_, id) => this.setFilter('floorPositionId', id)}
              />
            ), [
              {name: 'floorMin', placeholder: 'От', handler: this.getHandlerInt('floorMin', 3)},
              {name: 'floorMax', placeholder: 'До', handler: this.getHandlerInt('floorMax', 3)}
            ])}
          </div>
          <div className='container__column'>
            {this.renderMultiSelect('Планировка', 'planningId', this.planningItems)}
            {this.renderMultiSelect('Санузел', 'sanitaryId', this.sanitaryItems)}
            {this.renderMultiSelect('Состояние / ремонт', 'renovationTypeId', this.renovationTypeItems, true)}

            {this.renderControlGroup('Балкон / лоджия', (
              <Checkbox
                label='Балкон или лоджия'
                checked={this.getFilter('hasBalcony')}
                onUpdate={(_, state) => this.setFilter('hasBalcony', state ? 1 : null)}
              />
            ))}
          </div>
          <div className='container__column'>
            {this.renderMultiSelect('Материал окон', 'windowTypeId', this.windowTypeItems)}
            {this.renderMultiSelect('Вид из окна', 'windowViewId', this.windowViewItems)}
            {this.renderMultiSelect('Расположение в доме', 'isCorner', this.cornerItems)}
          </div>
        </div>
      </div>

      <div className='filter-section__container'>
        <h3 className='title'>Параметры дома</h3>

        <div className='container__row'>
          <div className='container__column'>
            {this.renderMultiSelect('Тип дома', 'buildingTypeId', this.buildingTypeItems, true)}
            {this.renderMultiSelect('Материал дома', 'materialId', this.materialTypeItems, true)}
          </div>
          <div className='container__column'>
            {this.renderInputGroup('Дом не ниже, этажей', null, [
              {name: 'floorTotalMin', placeholder: 'Число', handler: this.getHandlerInt('floorTotalMin', 7)}
            ])}

            {this.renderInputGroup('Год постройки', null, [
              {name: 'builtYearMin', placeholder: 'От', handler: this.getHandlerInt('builtYearMin', 4)},
              {name: 'builtYearMax', placeholder: 'До', handler: this.getHandlerInt('builtYearMax', 4)}
            ])}
          </div>
          <div className='container__column'>
            { this.renderIsRelease() }
            {
              this.getFilter('isNewBuilding') &&
              this.renderControlGroup('Срок сдачи', (
                <Select
                  name='deadlineId' scrolling
                  items={this.deadlineItems}
                  value={this.getFilter('deadlineId')}
                  onUpdate={(_, id) => this.setFilter('deadlineId', id)}
                />
              ))
            }
          </div>
        </div>
      </div>

      <div className='filter-section__container'>
        <h3 className='title'>Прочие параметры</h3>

        <div className='container__row'>
          <div className='container__column'>
            {this.renderMultiSelect('Агентство / застройщик', 'agencyId', this.agenciesList, true, 'Неважно', true)}
            {this.renderInputGroup('Номер объявления', null, [
              {name: 'id', placeholder: '12345678', handler: this.getHandlerInt('id')}
            ])}
          </div>
          <div className='container__column'>
            {this.renderInputGroup('Поиск в описании', null, [
              {name: 'description', placeholder: 'Ключевые слова', handler: this.getHandlerString('description')}
            ])}
            {this.renderInputGroup('Контактный телефон', null, [
              {name: 'contactPhone', placeholder: '123 456 78 90', handler: this.getHandlerInt('contactPhone')}
            ])}
          </div>
          <div className='container__column'>
          {this.renderControlGroup('Условия сделки', (
              <div>
                <Checkbox
                  label='Ипотека'
                  checked={this.getFilter('isMortgageAvailable')}
                  onUpdate={(_, state) => this.setFilter('isMortgageAvailable', state ? 1 : null)}
                />
                <Checkbox
                  label='Чистая продажа'
                  checked={this.getFilter('isClearSale')}
                  onUpdate={(_, state) => this.setFilter('isClearSale', state ? 1 : null)}
                />
                <Checkbox
                  label='Обмен'
                  checked={this.getFilter('isExchange')}
                  onUpdate={(_, state) => this.setFilter('isExchange', state ? 1 : null)}
                />
              </div>
            ))}
            { this.renderAuthor() }
            {this.getUserIsAdmin() && this.renderMultiSelect('Приложения', 'sourceAppId', this.applicationItems, true)}
          </div>
        </div>
      </div>
    </div>);
  }
}

export default SaleApartments;



// WEBPACK FOOTER //
// ./src/ui/Search/ExtendSearch/SaleApartments.jsx